import { IUploadFileListItem } from "../interfaces/upload-file-list-item.interface";
import { UploadFile } from "./upload-file.class";

export class UploadFileListItem {
  uploadFile: UploadFile;
  isProgressing?: boolean;

  constructor(props: IUploadFileListItem) {
    this.uploadFile = props.uploadFile;
    this.isProgressing = props.isProgressing;
  }
}
